import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
// import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";

function ContactForm() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      toast.error("All fields are required");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://arkane.in/apijob/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.success) {
        toast.success("Message sent successfully!");
        setForm({ name: "", email: "", message: "" });
      } else {
        toast.error(data.message || "Submission failed");
      }
    } catch (error) {
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="animate-section-trigger">
    <ToastContainer
                     position="top-right"
                  autoClose={3000}
                  limit={1}
                  closeOnClick
                  pauseOnHover
                  draggable
                    />
      <div className="section">
        <div className="base-container w-container">
          <div className="contacts-wrapper">

            {/* LEFT CONTENT */}
            <div className="contacts-content-wrapper">
              <div className="contacts-title">
                <h3>Get In Touch With Us</h3>
              </div>
              <p className="paragraph-large mt-20">
                Contact us today to discuss your project requirements.
              </p>
              <div className="contacts-divider"></div>

              <div className="contacts-detail-wrapper">
                <div className="contacts-detail">
                  <p className="paragraph-contact-us">
                    #17 & 18, Simhapuri Township, Jigani, Bengaluru, Karnataka-560105
                  </p>
                </div>
  <div className="contacts-detail">
                  <a href="tel:+919187650900" className="paragraph-contact-us">
                     Ph no: +91 9187650900
                  </a>
                </div>
                <div className="contacts-detail">
                  <a href="tel:080-28282221" className="paragraph-contact-us">
                    Tel: 080-28282221
                  </a>
                </div>

                <div className="contacts-detail">
                  <a href="mailto:info@arkane.in" className="paragraph-contact-us">
                    Mail: info@arkane.in
                  </a>
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="contacts-form-wrapper">
              <h3 className="contacts-form-title">Send us a message</h3>

              <form className="w-form" onSubmit={handleSubmit}>
                <input
                  className="contacts-input w-input"
                  name="name"
                  placeholder="Your name"
                  type="text"
                  value={form.name}
                  onChange={handleChange}
                  required
                />

                <input
                  className="contacts-input w-input"
                  name="email"
                  placeholder="Your email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />

                <textarea
                  className="contacts-textarea w-input"
                  name="message"
                  placeholder="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                />

                <input
                  type="submit"
                  className="primary-button full-width-mobile w-button"
                  value={loading ? "Please wait..." : "Submit"}
                  disabled={loading}
                />
              </form>
            </div>

          </div>
        </div>
        <div className="gradient-baclground"></div>
      </div>
    </div>
  );
}

export default ContactForm;
